export const weekDayShortNames = {
	Monday: 'M',
	Tuesday: 'T',
	Wednesday: 'W',
	Thursday: 'T',
	Friday: 'F',
	Saturday: 'S',
	Sunday: 'S',
};
